import { create } from 'zustand';
import { getApproximateSunTimes, getTimeOfDayState, type TimeOfDayState } from '../lib/timeOfDay.js';

interface TimeOfDayStore extends TimeOfDayState {
  sunrise: string;
  sunset: string;
  phaseOverride: string | null;
  refresh: () => void;
  setPhaseOverride: (phase: string | null) => void;
}

function createState(): TimeOfDayState & Pick<TimeOfDayStore, 'sunrise' | 'sunset'> {
  const now = new Date();
  return { ...getTimeOfDayState(now), ...getApproximateSunTimes(now) };
}

export const useTimeOfDayStore = create<TimeOfDayStore>((set) => ({
  ...createState(),
  phaseOverride: null,
  refresh: () => set(createState()),
  setPhaseOverride: (phase) => set({ phaseOverride: phase }),
}));

if (typeof window !== 'undefined') {
  window.setInterval(() => {
    useTimeOfDayStore.getState().refresh();
  }, 60_000);
}
